import React from 'react';
import FaTrophy from 'react-icons/lib/fa/trophy';
var selfStyles = require('./styles.scss');
var IconTrophySecond = function (props) { return (React.createElement(FaTrophy, { className: selfStyles.second })); };
export default IconTrophySecond;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/IconDashboard/IconTrophySecond.tsx
// module id = 673
// module chunks = 0